import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ForgotPasswordComponent } from './components/pages/forgot-password/forgot-password.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { SignInComponent } from './components/pages/sign-in/sign-in.component';
import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { EmployeeValidatorGuard } from './employee-validator.guard';
import { SessionValidatorGuard } from './session-validator.guard';

const routes: Routes = [
  { path: '', component: HomeOneComponent },

  { path: 'sign-in', component: SignInComponent },
  {
    path: 'sign-up',
    canActivate: [SessionValidatorGuard],
    component: SignUpComponent,
  },
  { path: 'forgot-password', component: ForgotPasswordComponent },

  { path: '404', component: ErrorComponent },
  { path: 'services', component: ServicesComponent },

  { path: 'contact', component: ContactComponent },

  {
    path: 'employee',
    canActivate: [EmployeeValidatorGuard],
    loadChildren: () =>
      import('./components/pages/employee/employee.module').then(
        (m) => m.EmployeeModule
      ),
  },

  // Here add new component

  { path: '**', component: ErrorComponent }, // This line will remain down from the whole component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
